// @flow

import _ from 'lodash/fp';
import React from 'react';
import classNames from 'classnames';
import './CustomerOrderPrice.css';
import FormattedPrice from '../FormattedPrice/FormattedPrice';
import {DEMO} from '../../roles.js';

const mapWithIndex = _.map.convert({cap: false});

export type Props = {
  roomPrices: any[],
  additionalTotalPrice: {
    open: boolean,
    price: number,
  },
  discount: number,
  totalPrice: number,
  toggleRoomPrice: number => void,
  toggleAdditionalPrice: () => void,
  togglePrices: () => void,
  customRows: any[],
  expanded: boolean,
  userRole: number,
};

const CustomerOrderPrice = ({
  roomPrices,
  discount,
  additionalTotalPrice,
  totalPrice,
  toggleRoomPrice,
  toggleAdditionalPrice,
  togglePrices,
  customRows,
  expanded,
  userRole,
}: Props) => [
  ...(!!expanded
    ? [
      <div
        key={0}
        onClick={togglePrices}
        className="CustomerOrderPrice-wrapper">
      </div>,
    ] : []),
  <div
    key={1}
    className="CustomerOrderPrice">
    { userRole !== DEMO &&
    <div
      onClick={togglePrices}
      className={classNames({
        'CustomerOrderPrice-top': true,
        'clickable': true,
        'is-open': !!expanded,
      })}>

      <div className="CustomerOrderPrice-total">
        <div className="CustomerOrderPrice-total-label">
          Dina tillval
        </div>
        <div className="CustomerOrderPrice-total-price">
          <FormattedPrice value={totalPrice} />
        </div>
      </div>
      <div className="CustomerOrderPrice-chevron">
        <i className={classNames({
          'fa': true,
          'fa-angle-down': !!expanded,
          'fa-angle-right': !expanded,
        })} />
      </div>
    </div>
    }
    {!!expanded && (
      <div className="CustomerOrderPrice-expanded">
        {mapWithIndex((r, idx) => [
          <div
            key={r.id}
            onClick={() => {
              if (!!r.prices.orderRows && !!r.prices.orderRows.length) {
                toggleRoomPrice(r.id);
              }
            }}
            className={classNames({
              'CustomerOrderPrice-room': true,
              'is-open': !!r.open,
              'clickable': !!r.prices.orderRows && !!r.prices.orderRows.length,
              'even': idx % 2 === 0,
            })}>
            <div className="CustomerOrderPrice-room-label">
              {r.name}
              {!!r.prices.orderRows.length && (
                <i className={classNames({
                  'fa': true,
                  'fa-angle-down': !!r.open,
                  'fa-angle-right': !r.open,
                })} />
              )}
            </div>
            <div className="CustomerOrderPrice-room-price">
              <FormattedPrice value={r.prices.totalPrice} />
            </div>
          </div>,
          ...(r.open
            ? _.map(x => (
              <div
                key={x.id}
                className={classNames({
                  'CustomerOrderPrice-product': true,
                  'even': idx % 2 === 0,
                })}>
                <div className="CustomerOrderPrice-product-label">
                  {x.name}
                </div>
                <div className="CustomerOrderPrice-product-price">
                  <FormattedPrice value={x.totalPrice} />
                </div>
              </div>
            ), r.prices.orderRows)
            : []
          )], roomPrices)
        }
        {!!additionalTotalPrice.price && (
          <div
            key={-1}
            onClick={() => {
              if (!!customRows && !!customRows.length) {
                toggleAdditionalPrice();
              }
            }}
            className={classNames({
              'CustomerOrderPrice-appended': true,
              'is-open': !!additionalTotalPrice.open,
              'clickable': !!customRows && !!customRows.length,
              'even': roomPrices.length % 2 === 0,
            })}>
            <div className="CustomerOrderPrice-appended-label">
              Extra tillvalsprodukter
              {!!customRows && !!customRows.length && (
                <i className={classNames({
                  'fa': true,
                  'fa-angle-down': !!additionalTotalPrice.open,
                  'fa-angle-right': !additionalTotalPrice.open,
                })} />
              )}
            </div>
            <div className="CustomerOrderPrice-appended-price">
              <FormattedPrice value={additionalTotalPrice.price} />
            </div>
          </div>
        )}
        {!!additionalTotalPrice.open && !!customRows && !!customRows.length &&
          _.map(x => (
            <div
              key={x.id}
              className={classNames({
                'CustomerOrderPrice-product': true,
                'even': roomPrices.length % 2 === 0,
              })}>
              <div className="CustomerOrderPrice-product-label">
                {x.name}
              </div>
              <div className="CustomerOrderPrice-product-price">
                <FormattedPrice value={x.totalSellingPrice} />
              </div>
            </div>
          ), customRows)
        }
        {!!discount && (
          <div
            key={-3}
            className={classNames({
              'CustomerOrderPrice-discount': true,
              'even': (roomPrices.length + (!!additionalTotalPrice.price ? 1 : 0)) % 2 === 0,
            })}>
            <div className="CustomerOrderPrice-discount-label">
              Rabatt
            </div>
            <div className="CustomerOrderPrice-discount-price">
              - <FormattedPrice value={discount} />
            </div>
          </div>
        )}
      </div>
    )}
  </div>,
];

export default CustomerOrderPrice;



// WEBPACK FOOTER //
// ./src/components/CustomerOrderPrice/CustomerOrderPrice.js